import { Markup } from '@technology/web3d-plugin-markup';

/** Shared fields for every measurement variant (see `measurement.ts` union). */
export interface BaseMeasurement {
  id: string;
  markups: Markup[];
  color?: {
    r: number;
    g: number;
    b: number;
    a?: number;
  };
  hidden?: boolean;
  savedStatus?: MeasurementSaveStatus;
}

export type MeasurementSaveStatus =
  | 'save_failed'
  | 'saving_in_progress'
  | 'save_successful';

export enum LineStyle {
  Solid = 'solid',
  Dashed = 'dashed',
  Dotted = 'dotted',
}
